import { BUTTON_TYPE } from "component/design-system/buttons/PAButton";
import { productNotFitHelper } from "modules/fitment/fitment-helper";
import AddToCartContainer from "./add-to-cart/AddToCartContainer";
import styles from "./productHeaderRightSection.module.scss";

function ProductHeaderRightSection(props: any) {
  const {
    className, saveButtonWithText, classActionContainer, product, setSyncProduct, isMobile = false,
  } = props;
  const {
    pickUpAvailable, shippingAvailable, outOfStock, limitedQuantityDetails,
  } = product;
  const isProductNotFit = productNotFitHelper(product);

  return (
    <div className={`${styles.add_to_cart} ${className} row-no-padding-xs ${isMobile ? styles.add_to_cart_mobile : ""}`}>
      <AddToCartContainer
        outOfStock={outOfStock}
        limitedQuantityDetails={limitedQuantityDetails}
        pickUpAvailable={pickUpAvailable}
        shippingAvailable={shippingAvailable}
        saveButtonWithText={saveButtonWithText}
        classActionContainer={classActionContainer}
        product={product}
        setSyncProduct={setSyncProduct}
        {...{
          ...(isProductNotFit && { addToCartButtonType: BUTTON_TYPE.SECONDRY_OUTLINE, addToCartClassName: styles.add_to_cart_button }),
        }}
      />
    </div>
  );
}

export default ProductHeaderRightSection;
